export default {
    stripe: '',
    stripeElements: '',
    stripeAPIToken: process.env.MIX_VUE_APP_STRIPE_PUBLIC_KEY,
    stripeStyles: {
        base: {
            color: '#262626',
            fontFamily: '"Noto Sans", Helvetica, sans-serif',
            fontSmoothing: 'antialiased',
            fontSize: '1rem',
            '::placeholder': {
                color: '#262626'
            }
        },
        invalid: {
            color: '#fa755a',
            iconColor: '#fa755a'
        }
    },

    getStripeData(){
        return {
            stripe: this.stripe,
            elements: this.stripeElements,
            styles: this.stripeStyles
        }
    },

    overwriteStripeSettings(token, paymentFlowType){
        if (paymentFlowType === 'platform_account') {
            this.stripe = Stripe( this.stripeAPIToken );
            this.stripeElements = this.stripe.elements({onBehalfOf: token});
        }
        else {
            this.stripe = Stripe( this.stripeAPIToken, {
                stripeAccount: token
            });
            this.stripeElements = this.stripe.elements();
        }
    },

    async loadStripe(whitelabel) {
        await this.includeStripe('js.stripe.com/v3/', function(){
            this.stripe = Stripe( this.stripeAPIToken, {
                stripeAccount: whitelabel.state.settings.stripe_id
            });
            this.stripeElements = this.stripe.elements();
        }.bind(this) );
    },

    includeStripe(URL, callback) {
        let documentTag = document, tag = 'script',
            object = documentTag.createElement(tag),
            scriptTag = documentTag.getElementsByTagName(tag)[0];
        object.src = '//' + URL;
        if (callback) {
            object.addEventListener('load', function (e) {
                callback(null, e);
            }, false);
        }
        scriptTag.parentNode.insertBefore(object, scriptTag);
    },
}
